// frontend/src/components/athleteEditor/staffProfileIcons.jsx
// Inline SVG icons for the staff read view of /athletes/:userId (feather-style,
// stroke 2 unless a filled glyph). All decorative: the text beside each one
// carries the meaning, so every icon is aria-hidden.
import React from 'react';

const stroke = (size, width = 2) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeWidth: width, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true, focusable: 'false',
});

export const ChevronLeftIcon = ({ size = 14 }) => (
  <svg {...stroke(size, 2.2)}><path d="M15 18l-6-6 6-6" /></svg>
);

export const ArrowUpRightIcon = ({ size = 12 }) => (
  <svg {...stroke(size, 2.2)}><path d="M7 17L17 7M7 7h10v10" /></svg>
);

export const CheckIcon = ({ size = 11, width = 3 }) => (
  <svg {...stroke(size, width)}><path d="M20 6L9 17l-5-5" /></svg>
);

export const AppleIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M16.37 12.64c-.03-2.6 2.13-3.85 2.22-3.91-1.21-1.77-3.09-2.01-3.76-2.04-1.6-.16-3.12.94-3.93.94-.81 0-2.06-.92-3.39-.89-1.74.03-3.35 1.01-4.25 2.57-1.81 3.14-.46 7.79 1.3 10.34.86 1.25 1.89 2.65 3.24 2.6 1.3-.05 1.79-.84 3.36-.84 1.57 0 2.01.84 3.39.81 1.4-.03 2.28-1.27 3.14-2.52.99-1.45 1.4-2.85 1.42-2.92-.03-.01-2.72-1.04-2.74-4.14zM13.79 5.01c.72-.87 1.2-2.08 1.07-3.28-1.03.04-2.28.69-3.02 1.55-.66.77-1.24 1.99-1.09 3.17 1.15.09 2.32-.58 3.04-1.44z" />
  </svg>
);

export const AndroidIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.29-.15-.65-.06-.83.22l-1.88 3.24a11.43 11.43 0 0 0-8.94 0L5.65 5.67c-.19-.29-.58-.38-.87-.2-.28.18-.37.54-.22.83L6.4 9.48A10.81 10.81 0 0 0 1 18h22a10.81 10.81 0 0 0-5.4-8.52zM7 15.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm10 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z" />
  </svg>
);

export const GlobeIcon = ({ size = 18 }) => (
  <svg {...stroke(size)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
  </svg>
);

// Read-only verified mark (a span, not a control) for places where nobody can
// toggle it: Academics, and Measurables for a viewer without canVerify.
export function VerifiedSeal({ small = false }) {
  return (
    <span className={`adm-seal${small ? ' adm-seal--sm' : ''}`} title="Verified" role="img" aria-label="Verified">
      <CheckIcon size={small ? 9 : 11} width={small ? 3.5 : 3} />
    </span>
  );
}
